// to convert query param object to query string

import * as Constants from '../constants/index';
import isEmpty from 'lodash/isEmpty';
import lodashGet from 'lodash/get';
import cuid from 'cuid';
import cookie from 'js-cookie';

export let isTimerRunning = false;
let timeOut;

export function encodeQueryParams(queryParams) {
  let esc = encodeURIComponent;
  let query = Object.keys(queryParams)
    .map(k => esc(k) + '=' + esc(queryParams[k]))
    .join('&');
  return query
}

// Not being used anywhere
export function getOrderType(cart) {
  const healthcareItem = cart.data && cart.data.medicine && cart.data.medicine.items && cart.data.medicine.items.length;
  const medicineItem = cart.data && cart.data.medicine && cart.data.healthcare.items && cart.data.healthcare.items.length;
  if (healthcareItem && medicineItem) {
    return Constants.OrderTypeCodeMapping.atcOrder;
  } else if (healthcareItem) {
    return Constants.OrderTypeCodeMapping.medicineOrder;
  } else {
    return Constants.OrderTypeCodeMapping.otcOrder;
  }
}
export function getSelectedComponentId() {
  let selectedComponent = 0;

  if (deliveredOrders.data && deliveredOrders.data.length > 0) {
    selectedComponent = 3;
  }

  if (deliveredMedicines.data && deliveredMedicines.data.length > 0) {
    selectedComponent = 2;
  }

  if (refills.data && refills.data.length > 0) {
    selectedComponent = 1;
  }

  if (customerDetails.data.newUser) {
    selectedComponent = 0;
  }

}

export function getCartItemForProduct(product, cart) {
  const res = {
    quantity: 0,
    itemId: undefined
  };

  if (!cart.data || (cart.data === null)) {
    return res;
  }

  const {
    data: {
      itemsCount,
      medicine = { items: [] },
      healthcare = { items: [] }
    }
  } = cart;
  if (!(itemsCount > 0)) {
    return res;
  }
  const { productIdIndexMap: { medicineProductIdMap, otcProductIdMap, customItemMap } } = cart;

  if (medicineProductIdMap[product.productId] !== undefined) {
    return medicine.items[medicineProductIdMap[product.productId]];
  } else if (otcProductIdMap[product.productId] !== undefined) {
    return healthcare.items[otcProductIdMap[product.productId]];
  } else if (product.flagId === Constants.customMedicineFalgId && customItemMap[product.name.toUpperCase()] !== undefined) {
    return medicine.items[customItemMap[product.name.toUpperCase()]];
  }

  return res;
}

export function getCartItemForProductV5(product, cart) {
  const res = {
    quantity: 0,
    itemId: undefined
  };

  if (!cart.data || (cart.data === null)) {
    return res;
  }

  const {
    data: {
      itemsCount,
      items,
    }
  } = cart;
  if (!(itemsCount > 0)) {
    return res;
  }
  const { productIdIndexMap: { medicineProductIdMap, otcProductIdMap, customItemMap } } = cart;

  if (medicineProductIdMap[product.productId] !== undefined) {
    return items[medicineProductIdMap[product.productId]];
  } else if (otcProductIdMap[product.productId] !== undefined) {
    return items[otcProductIdMap[product.productId]];
  } else if (product.flagId === Constants.customMedicineFalgId && customItemMap[product.name.toUpperCase()] !== undefined) {
    return items[customItemMap[product.name.toUpperCase()]];
  }

  return res;
}

export function getSwappedProduct(product) {
  if (!isEmpty(product.swappedProductDetails)) {
    let name = product.swappedProductDetails[0].name;
    if (confirm('This product is swapped by ' + name + ',Press OK to proceed.')) {
      return { name, shouldSwap: true };
    }
    return { name, shouldSwap: false };
  }
}
export function addAllMedicines(actions, orderId, isNewOrderFlow = false) {
  const shouldProceed = confirm(`Add all items of Order No. ${orderId} to cart?`);
  if (!shouldProceed) {
    return;
  }
  actions
    .reorder({ orderId, shouldReplace: 0 }, isNewOrderFlow)
    .then((resp) => {
      if (!resp.isReorderSuccessful) {
        alert(
          resp.cartReorderAlertText || resp.message || "Something Went Wrong!"
        );
      }
    });
}
//
// export function filterCities(cities , keyword){
//   keyword = keyword.toLowerCase();
//   return cities && cities.filter(function(city){ city = city.toLowerCase(); return city.includes(keyword)})
// }
//
// export function getUrl(path , queryParam){
//   let query = encodeQueryParams(queryParam);
//   let url = path
//   url = url+"?"+query
//   return url
// }

/**
 * uploads images to respective link
 * @param array linkArray
 * @param array imagesArray
 * @returns Promise
 */
export function uploadImagesToS3(linkArray, imagesArray) {
  var requestParams = {
    method: 'PUT',
    mode: 'cors',
    headers: {
      'Content-Disposition': 'inline'
    },
  }, pdfImages = [], imgImages = [];

  imagesArray.forEach(function (value) {
    if (value.type.indexOf(Constants.FILE_TYPE.pdf) !== -1) {
      pdfImages.push(value);
    } else {
      imgImages.push(value);
    }
  });
  const promiseArray = linkArray.map(async ({ url, type }, index) => {
    let isPdf = (type === Constants.FILE_TYPE.pdf);
    let { file, url: objectUrl, type: fileType } = isPdf ? pdfImages.pop() : imgImages.pop();

    if (!file) {
      file = await fetch(objectUrl)
        .then(response => response.arrayBuffer())
        .then(buffer => {
          return new File([buffer], { type: fileType });
        });
    }
    requestParams.headers['Content-Type'] = isPdf ? 'application/pdf' : 'image/*';
    return fetch(url, { ...requestParams, body: file });
  });
  return Promise.all(promiseArray);
}

export function debouncePE(waitTime, callback) {
  if (isTimerRunning) {
    clearTimeout(timeOut);
  }

  isTimerRunning = true;
  timeOut = setTimeout(() => {
    callback();
    isTimerRunning = false;
  }, waitTime);
}

export function generateSurveyLink(user, customer, order = {}) {
  const { data: { userEmail: agentEmail } } = user;
  const { customerDetails: { data: { newUser, profile: { id: customerId } } } } = customer;
  const orders = lodashGet(order, 'data.data.orders');

  const surveyBaseUrl = newUser ? 'https://pharmeasy.typeform.com/to/BKC8Ou' : 'https://pharmeasy.typeform.com/to/yEq4nc';

  const params = [
    `customer_id=${customerId}`,
    `agent_name=${agentEmail}`
  ];

  if (orders) {
    let { medicineOrder, healthcareOrders } = orders;
    let orderID = medicineOrder ? medicineOrder.id : (healthcareOrders[0] && healthcareOrders[0].id);
    params.push(`Order_ID=${orderID}`);
  }

  return `${surveyBaseUrl}?${params.join('&')}`;
}

export function createItemQtyArray(count) {
  let data = [];
  if (!count) {
    return [];
  }
  for (let i = 0; i <= count; i++) {
    data.push({ value: i, label: i });
  }
  data[data.length - 1].subText = 'Max Qty';

  return data;
}

export function createLoyaltyVariantsArray(count) {
  let data = [];
  if (!count) {
    return [];
  }
  for (let i = 0; i < count.length; i++) {
    data.push({ value: count[i].id, label: count[i].description });
  }

  return data;
}

export function createDiagLoyaltyVariantsArray(variants) {
  let data = [];
  variants.forEach(variant => {
    data.push({
      value: variant.id,
      label: variant.duration,
    });
  });
  return data;
}

export function setDeviceFingerprint() {
  if (!cookie.get('X-Device-Id')) {
    const fingerprint = cuid();
    cookie.set('X-Device-Id', fingerprint, { expires: 365, secure: process.env.NODE_ENV === 'production' });
  }
}

export const isFastingRequired = (cartData) => {
  const itemArray = lodashGet(cartData, 'test_details', []);
  return !!itemArray.find(
    item => item.fasting_type && item.fasting_type !== "not required"
  );
};
